export default () => ({
  isIntroHidden: true,
  isMapLoaded: false,
  get totalInvestmentAmount() {
    return new Intl.NumberFormat('cs-CZ').format(
      this.$store.global.totalInvestmentAmount
    );
  },
  hideIntro() {
    this.isIntroHidden = true;
    this.$dispatch('hide-intro');
    this.$store.global.isIntrohidden = true;
  },
  showIntro() {
    this.isIntroHidden = false;
    this.$dispatch('show-intro');
    this.$store.global.isIntrohidden = false;
    this.$dispatch('navigate', '/');
  },
  onMapLoaded() {
    this.isMapLoaded = true;
  },
  init() {
    if (!localStorage.getItem('show-map')) {
      localStorage.setItem('show-map', '0');
    }

    if (localStorage.getItem('show-map') === '0') {
      this.showIntro();
    }

    const introButton = document.getElementById('intro-button');
    const buttonHoverCircle = document.getElementById('btn-hover-circle');

    let animTimeout = null;

    const { top } = introButton.getBoundingClientRect();
    const { left } = introButton.getBoundingClientRect();

    introButton.addEventListener('mousemove', (e) => {
      const coords = {
        x: e.clientX - left,
        y: e.clientY - top
      };
      buttonHoverCircle.style.left = `${coords.x}px`;
      buttonHoverCircle.style.top = `${coords.y}px`;
    });

    introButton.addEventListener('click', (e) => {
      e.preventDefault();

      clearTimeout(animTimeout);
      buttonHoverCircle.classList.remove('isActive');
      buttonHoverCircle.classList.add('isActive');

      animTimeout = setTimeout(() => {
        buttonHoverCircle.classList.remove('isActive');
      }, 300);

      localStorage.setItem('show-map', '1');
      this.$dispatch('show-map');
    });

    introButton.addEventListener('mouseleave', () => {
      buttonHoverCircle.style.left = '-500px';
      buttonHoverCircle.style.top = '-500px';
    });
  }
});
